import { actions, mutations } from "@/constants/state";
import { checkDomain, updateJoinDinnerConfig } from "@/services/domain-service";

export default {
  [actions.DOMAIN_FETCH_ACTION]: async ({ commit }) => {
    const { data } = await checkDomain(window.location.hostname);
    commit(mutations.DOMAIN_FETCH_MUTATION, data);
  },

  [actions.JOIN_DINNER_UPDATE_ACTION]: async (
    { commit },
    { locationId, isJoinDinnerEnabled, joinDinnerRange }
  ) => {
    const { data } = await updateJoinDinnerConfig(
      locationId, {
        isJoinDinnerEnabled, joinDinnerRange
      }
    );

    console.log(data)
    commit(mutations.JOIN_DINNER_FETCH_MUTATION, data);
  },
};
